var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-left mb-0 c-title",class:_vm.isMobile ? 'text-h6' : 'text-h5',style:({ color: _vm.color != undefined ? _vm.color : '#175082' })},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }